import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type SiteImageFragment = { id: string, pk: number, alt: string, description: string, title: string, annotation: string, thumbnailUrl: string | null, mobileThumbnailUrl: string | null, useInSlider: boolean, link: string, buttonTitle: string, categoryId: string | null };

export const SiteImageFragmentDoc = gql`
    fragment SiteImageFragment on BannerImageType {
  id
  pk
  alt
  description
  title
  annotation
  thumbnailUrl(size: "2000x0", method: CROP)
  mobileThumbnailUrl(size: "600x0", method: CROP)
  useInSlider
  link
  buttonTitle
  categoryId
}
    `;